// extracted by mini-css-extract-plugin
module.exports = {"button":"QsrCreateOrderButton_button__8uJcC"};